import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';
import { UsersApiAdapter } from '../adapters/UsersApiAdapter';
import { Service } from '../services/Service';

/**
 * Hook para obtener todos los usuarios
 * Los filtros se aplican localmente en el componente
 */
export const useUsers = () => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new UsersApiAdapter(httpClient);
  const service = new Service(apiAdapter);

  const {
    data: users,
    isLoading,
    error,
    refetch,
    isFetching,
  } = useQuery({
    queryKey: ['users'],
    queryFn: () => service.getAll({}),
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos
  });

  return {
    users: users || [],
    isLoading,
    error,
    refetch,
    isFetching,
  };
};

